import Delta from 'quill-delta';
import diff, { isOperationSupported } from '../../adapter/editor/diff';
import apply from '../../adapter/editor/apply';
export default (function () {
  var changes = [];
  return [{
    commands: {
      applyRemoteChanges: function applyRemoteChanges(editor, delta) {
        editor.tmp.applyingRemoteChanges = true;
        apply(delta, editor);
        editor.tmp.applyingRemoteChanges = false;
        return editor;
      },
      flushLocalChanges: function flushLocalChanges() {
        changes = [];
      }
    },
    queries: {
      isApplyingRemoteChange: function isApplyingRemoteChange(editor) {
        return Boolean(editor.tmp.applyingRemoteChanges);
      },
      getLocalChanges: function getLocalChanges() {
        return changes.reduce(function (delta, op) {
          return delta.compose(op);
        }, new Delta());
      }
    },
    onConstruct: function onConstruct(editor, next) {
      changes = [];
      editor.tmp.undo = false;
      return next();
    },
    onCommand: function onCommand(command, editor, next) {
      if (command.type === 'undo' || command.type === 'redo') {
        editor.tmp.undo = true;
        var result = next();
        editor.tmp.undo = false;
        return result;
      } else if ((editor.tmp.save !== false || editor.tmp.undo === true) && command.type === 'save' && isOperationSupported(command.args[0])) {
        var delta = diff(command.args[0], editor);

        if (delta.ops.length) {
          changes.push(delta);
        }
      }

      return next();
    },
    onChange: function onChange(editor, next) {
      var result = next();
      editor.flushLocalChanges();
      return result;
    }
  }];
});